import type { ReactNode } from 'react';
import { Outlet } from 'react-router';
import { useSession } from '@/features/auth';
import { ForbiddenPage } from '@/shared/ui/feedback';

/**
 * Elemento de rota das telas do admin geral da plataforma (ADR-0021): sem a sessão de admin
 * geral, mostra "Acesso negado" dentro do layout. Os loaders usam `requirePlatformAdmin`.
 */
export function RequirePlatformAdmin(): ReactNode {
  const platformAdmin = useSession((state) => state.session?.platformAdmin === true);
  return platformAdmin ? <Outlet /> : <ForbiddenPage />;
}
